import { useQuery } from '@tanstack/react-query';

export function useProjectsAnalyticsCurrentProjectsReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalytics', 'currentProjectsReports', params],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_analytics/current_projects_reports',
        { current_projects_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
